var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1149 84.6001C50.5508 84.5983 49.993 84.4814 49.4763 84.2565C48.9596 84.0316 48.495 83.7036 48.1113 83.2929L28.1148 62.1731C27.3673 61.3822 26.9669 60.3289 27.0016 59.2448C27.0363 58.1608 27.5034 57.1349 28.3 56.3927C29.0966 55.6506 30.1575 55.253 31.2493 55.2875C32.3412 55.322 33.3745 55.7857 34.122 56.5766L51.0738 74.51L85.6769 36.9274C86.028 36.4932 86.4649 36.1349 86.9606 35.8745C87.4563 35.6141 88.0004 35.457 88.5595 35.413C89.1185 35.3689 89.6808 35.4388 90.2116 35.6183C90.7425 35.7979 91.2308 36.0832 91.6466 36.457C92.0623 36.8307 92.3967 37.2848 92.6292 37.7915C92.8617 38.2982 92.9875 38.8468 92.9987 39.4035C93.0099 39.9602 92.9064 40.5133 92.6945 41.0288C92.4825 41.5444 92.1667 42.0114 91.7664 42.4014L54.1597 83.2521C53.7797 83.6702 53.3167 84.0058 52.7998 84.2378C52.2829 84.4698 51.7233 84.5931 51.1561 84.6001H51.1149Z",
    fill: "#1CBB32"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -0.000488281,
    y: 0.00012207,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#1CBB32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.071af94f1d60f4a8387a15412726c83f.svg";
export { ForwardRef as ReactComponent };